import { IFormEmployee } from './EmployeeForm'
import { IEmployeeDetails, IEmployeeTableRecord } from '@api'

export function employeeDetailsToFormEmployee(employee: IEmployeeDetails): IFormEmployee {
  return {
    id: employee.id,
    name: employee.name,
    email: employee.email,
    phone: employee.phone,
    title: employee.title,
    employmentType: employee.employmentType,
    badge: employee.badge,
    department: employee.team
      ? { ...employee.team, parentDepartment: employee.dept }
      : employee.dept,
    geoLocation: employee.geoLocation,
    manager: employee.manager,
    startDate: employee.startDate,
    endDate: employee.endDate,
  }
}

export function employeeDetailsToTableRecord(employee: IEmployeeDetails): IEmployeeTableRecord {
  return {
    id: employee.id,
    isRemote: employee.isRemote,
    noDeskNeeded: employee.noDeskNeeded,
    assets: employee.assets,
    secondarySpaceAssignments: employee.secondarySpaceAssignments,
    spaceAssignment: employee.spaceAssignment,
    neighborhoods: employee.neighborhoods,
    imported: employee.imported,
    name: employee.name,
    email: employee.email,
    title: employee.title,
    employmentType: employee.employmentType,
    dept: employee.dept,
    team: employee.team,
    geoLocation: employee.geoLocation,
    manager: employee.manager,
    department: employee.department,
  }
}
